<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Finalização de Ciclo"
    :formErrors="formErrors"
    deleteConfirmButtonLabel="Finalizar"
    deleteIcon="mdi-lock"
    deleteButtonLabel="Finalizar Ciclo"
    deleteColor="green"
    :alwaysEnabled="true"
  >

    <BaseUtil
      ref="util"
      :pageLoading="loading"
    />
    <p> Você tem certeza que deseja finalizar o ciclo <b>{{this.entry.name}}</b>?</p>
    <p v-if="entry.status == 'in_progress'">IMPORTANTE: Esse ciclo não possui nenhuma colheita realizada. Está certo que deseja finalizar o ciclo mesmo assim?</p>

    <v-col cols="12" sm="6" md="4">
      <DateField
        :inputData.sync="entry.endDate"
        v-bind="getObject('endDate')"
        label="Data de finalização"
        :hasTodayButton="true"
        :hasTodayDate="true"
      />
    </v-col>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";
import DateField from "@shared_components/date_field.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
 data () {
  return {
    entryAttributes: {},
    error: null,
    loading: false,
    formErrors: [],
  }
},
components: {
  BaseDelete: BaseDelete,
  DateField: DateField,
  BaseUtil: BaseUtil,
},
props: {
  entry: Object,
},
 methods: {
  getObject: function(element, component) {
    return this.entryAttributes[element];
  },
   destroyServerEntry: function(period) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: FINALIZE_PERIOD_MUTATION,
          variables: {
            id: period.id,
            endDate: period.endDate,
          }
        })
        .then(response => {
          var errors = response.data.finalizePeriod.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const FINALIZE_PERIOD_MUTATION = gql `
  mutation($id: ID!, $endDate: ISO8601Date!) {
    finalizePeriod(id: $id, endDate: $endDate) {
      period {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>